module.exports = __webpack_public_path__ + "static/media/ss-thinktech.910bedcc.gif";